import { queryOptions } from '@tanstack/react-query'
import { apiClient } from '~/lib/client'

import { handleApiError } from '~/utils/response'
import { handleResponse } from '~/utils/response'

import { allergiesKeys } from './keys'
import { GetAllergiesResponse } from '../types'
import { buildQueryString } from '@workspace/lib/url'

export const medicalsAllergiesQueryOptions = (program: 'weight_loss' | 'urgent_care' = 'weight_loss') => {
    return queryOptions({
        queryKey: allergiesKeys.allergies(program),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/medicals/allergies${buildQueryString({ program })}`);

                const result = await  handleResponse<GetAllergiesResponse>(response);

                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
    });
};


export const medicalsAllergyQueryOptions = (id: string) => {
    return queryOptions({
        queryKey: allergiesKeys.allergy(id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/medicals/allergies/${id}`);

                const result = await  handleResponse(response);

                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },

    });
};



